import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { GlobalStyle } from "./components/App/styled";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/Screens/Error/ErrorFallback";

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
                <GlobalStyle />
                <App />
            </ErrorBoundary>
        </Router>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
